import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const UserInformation: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.16754 6.46321C4.65009 7.01782 4.3309 7.83476 4.3309 8.85821V15.1523C4.3309 16.1721 4.6483 16.9869 5.16453 17.5402C5.67569 18.0882 6.43257 18.4351 7.42871 18.4351H16.463C17.4637 18.4351 18.2204 18.0878 18.7304 17.5405C19.2455 16.9877 19.5617 16.173 19.5617 15.1523V8.85821C19.5617 7.83284 19.2452 7.01594 18.7306 6.46213C18.2216 5.91409 17.467 5.56731 16.471 5.56731H7.42871C6.43717 5.56731 5.68006 5.91389 5.16754 6.46321ZM4.15514 5.51863C4.95613 4.66015 6.09407 4.18269 7.42871 4.18269H16.471C17.8093 4.18269 18.9463 4.65994 19.7451 5.51972C20.5385 6.37373 20.9463 7.54843 20.9463 8.85821V15.1523C20.9463 16.4586 20.5381 17.6315 19.7433 18.4844C18.9434 19.343 17.8046 19.8198 16.463 19.8198H7.42871C6.09059 19.8198 4.95242 19.3426 4.15209 18.4848C3.35682 17.6323 2.94629 16.4595 2.94629 15.1523V8.85821C2.94629 7.54651 3.35909 6.37185 4.15514 5.51863Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.67412 14.8782C7.3982 15.1281 7.29282 15.4397 7.29282 15.7083C7.29282 16.0907 6.98286 16.4006 6.60051 16.4006C6.21815 16.4006 5.9082 16.0907 5.9082 15.7083C5.9082 15.0797 6.15668 14.3845 6.74453 13.852C7.33405 13.3179 8.20209 13.0024 9.34788 13.0024C10.4924 13.0024 11.3601 13.3152 11.9499 13.8467C12.5387 14.3773 12.7875 15.0711 12.7875 15.7002C12.7875 16.0826 12.4776 16.3926 12.0952 16.3926C11.7129 16.3926 11.4029 16.0826 11.4029 15.7002C11.4029 15.4321 11.298 15.1231 11.023 14.8753C10.749 14.6284 10.2431 14.387 9.34788 14.387C8.45402 14.387 7.94837 14.6297 7.67412 14.8782Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.34764 8.98197C8.76092 8.98197 8.28501 9.45788 8.28501 10.0446C8.28501 10.6314 8.76092 11.1072 9.34764 11.1072C9.93437 11.1072 10.4103 10.6314 10.4103 10.0446C10.4103 9.45788 9.93437 8.98197 9.34764 8.98197ZM6.90039 10.0446C6.90039 8.69318 7.99621 7.59736 9.34764 7.59736C10.699 7.59736 11.7949 8.69318 11.7949 10.0446C11.7949 11.396 10.699 12.4918 9.34764 12.4918C7.99621 12.4918 6.90039 11.396 6.90039 10.0446Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.212 10.4653C13.2172 10.0829 13.5314 9.77727 13.9137 9.78252L17.1191 9.82653C17.5014 9.83178 17.8071 10.146 17.8019 10.5282C17.7966 10.9106 17.4824 11.2162 17.1001 11.211L13.8947 11.167C13.5124 11.1618 13.2067 10.8475 13.212 10.4653ZM14.4135 13.8919C14.4135 13.5096 14.7234 13.1996 15.1058 13.1996H17.1095C17.4918 13.1996 17.8018 13.5096 17.8018 13.8919C17.8018 14.2743 17.4918 14.5842 17.1095 14.5842H15.1058C14.7234 14.5842 14.4135 14.2743 14.4135 13.8919Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
    </svg>
  );
};

export default UserInformation;
